import { render } from "./CheckBoxInputCustom.vue?vue&type=template&id=cd60ecd2"
import script from "./CheckBoxInputCustom.vue?vue&type=script&lang=js"
export * from "./CheckBoxInputCustom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__